import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { ComponentsModule } from '../components/components.module';
import { ChildComponentsModule } from '../components/child-components.module';
import { IquantaInitiativeComponent } from './iquanta-initiative.component';
import { CommonChildComponentsModule } from '../components/common-components.module'

export const routes:any[] = [
  {
    path: '', component: IquantaInitiativeComponent
  },
];


@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    ChildComponentsModule,
    CommonChildComponentsModule,
ComponentsModule,
  ],
  declarations: [
    IquantaInitiativeComponent
  ],
 
})
export class IquantaInitiativeModule { }